import axios from "axios";
import {DIGITAL_MENU_API} from "../config/config";


export const getDigitalMenuByExternalUUID = (uuid) => {
    return axios({
        url: `${DIGITAL_MENU_API}/${uuid}`,
        method: 'get'
    })
}